// Main calculator actions for add / delete rule

export const SET_CALC_TYPE = 'SET_CALC_TYPE';

export const GET_RULES = 'GET_RULES';
export const SET_RULES = 'SET_RULES';
export const GET_FORMULAE = 'GET_FORMULAE';
export const SET_FORMULAE= 'SET_FORMULAE';

export const GET_RULE = "GET_RULE";
export const SET_RULE = "SET_RULE";

export const SAVE_RULE = 'SAVE_RULE';
export const SAVED_RULE = 'SAVED_RULE';

export const COPY_RULE = 'COPY_RULE';

export const RULE_ERROR = 'RULE_ERROR';

export const DELETE_RULE = 'DELETE_RULE';
export const DELETED_RULE = 'DELETED_RULE';

export const UPDATE_RULE = 'UPDATE_RULE';
export const UPDATED_RULE = 'UPDATED_RULE';

export const TEST_RULE = 'TEST_RULE';
export const TESTED_RULE = 'TESTED_RULE';

export const GET_FORMULA = "GET_FORMULA";
export const SET_FORMULA = "SET_FORMULA";

export const SAVE_FORMULA = 'SAVE_FORMULA';
export const SAVED_FORMULA = 'SAVED_FORMULA';

export const UPDATE_FORMULA = 'UPDATE_FORMULA';
export const UPDATED_FORMULA = 'UPDATED_FORMULA';

export const MOVE_FORMULA = 'MOVE_FORMULA';
export const MOVE_RULE = 'MOVE_RULE';

export const DELETE_FORMULA = 'DELETE_FORMULA';
export const DELETED_FORMULA = 'DELETED_FORMULA';

export const FORMULA_ERROR = 'FORMULA_ERROR';
export const TEST_ERROR = 'TEST_ERROR';

export const GET_PARAMETERS = "GET_PARAMETERS";
export const SET_PARAMETERS = "SET_PARAMETERS";

export const GET_OPERATIONS = "GET_OPERATIONS";
export const SET_OPERATIONS = "SET_OPERATIONS";
export const GET_VARIABLES = "GET_VARIABLES";
export const SET_VARIABLES = "SET_VARIABLES";
export const GET_CONSTANTS = "GET_CONSTANTS";
export const SET_CONSTANTS = "SET_CONSTANTS";
export const SET_CONST_VALUE = 'SET_CONST_VALUE';
export const SAVE_CONSTANT = "SAVE_CONSTANT";
export const UPDATE_CONSTANT = "UPDATE_CONSTANT";
export const DELETE_CONSTANT = "DELETE_CONSTANT";
export const DELETED_CONSTANT = "DELETED_CONSTANT";

export const GET_FORMULAE_DEFS = "GET_FORMULAE_DEFS";
export const SET_FORMULAE_DEFS = "SET_FORMULAE_DEFS";

export const SET_CONSTANT_ID = "SET_CONSTANT_ID";
export const REMOVE_CONSTANT_ID = "REMOVE_CONSTANT_ID";

export const GET_FORM_FIELDS = "GET_FORM_FIELDS";
export const SET_FORM_FIELDS = "SET_FORM_FIELDS";
